import { range, where, each } from 'underscore';
import templateUrl from './forecastBettingArea.html';

(function () {
  angular.module('terminalApp.nabHorseRacesUi')
    .component('horseForecastBettingAreaTable', {
      templateUrl: templateUrl,
      controller: function (
        SevenGamesSvc,
        $state,
        $scope,
        BetslipService,
        NabNotifications,
        HorseRacesUiService
      ) {
        var currentUrl = $state.current.url.substring(1, $state.current.url.length);
        var activeGame = (currentUrl.charAt(0).toUpperCase() + currentUrl.slice(1)).toString(); var // switch virtual and regular greyhound races
          HorseRaces = SevenGamesSvc.getGame(activeGame);
        var BettingSvc = HorseRaces.getBettingSvc();
        var betslipSvc = BetslipService;
        var self = this;

        this.$onInit = function () {
          this.racersFirstPlace = range(1, HorseRaces.numberOfRacers + 1);
          this.racersSecondPlace = range(1, HorseRaces.numberOfRacers + 1);
          this.activeGame = HorseRaces;
          this.reverseForecast = false;
          this.horseRacesUISvc = HorseRacesUiService;
          this.createCombinations();
          this.horseRacesUISvc.disableReverseForecast = false;
          this.horseRacesUISvc.disableForecast = false;
        };

        this.createCombinations = function () {
          each(self.racersFirstPlace, function (firstPlace) {
            each(self.racersSecondPlace, function (secondPlace) {
              if (firstPlace != secondPlace) {
                self.horseRacesUISvc.forecast[firstPlace + '-' + secondPlace] = false;
              }
            });
          });
        };

        this.deactivateForecastRacers = function () {
          each(self.horseRacesUISvc.forecast, function (value, position, racer) {
            racer[position] = false;
          });
        };

        this.deactivateScheduledRacers = function () {
          each(self.horseRacesUISvc.scheduledEvents, function (event) {
            each(event.forecast, function (value, position) {
              event.forecast[position] = false;
            });
          });
        };

        this.toggleReverseForecast = function () {
          this.reverseForecast = !this.reverseForecast;

          self.deactivateForecastRacers();

          if (self.activeGame.isScheduleActive) {
            self.deactivateScheduledRacers();
          }

          self.enableActiveBets(betslipSvc.ticket.bets);
        };

        this.createForecastBet = function (first, second) {
          HorseRaces._bettingSvc.clearAll();
          HorseRaces._bettingSvc.ticketInput.input.push(first);
          HorseRaces._bettingSvc.ticketInput.secondPlace.push(second);

          var odd = HorseRaces._bettingSvc.systemBets.forecastOdds[first + '-' + second];

          return {
            bet: 'forecast',
            value: odd,
            racers: first + '-' + second
          };
        };

        this.sendBet = function (first, second) {
          var betToSend = null;

          if (this.reverseForecast) {
            betToSend = this.createReverseForecastBet(first, second);
            return;
          }
          betToSend = this.createForecastBet(first, second);

          this.toggleBet(betToSend);
        };

        this.createReverseForecastBet = function (first, second) {
          var bets = BetslipService.ticket.getBets();

          var activeBet = {
            key: 'reverseForecast',
            combinations: [
              first + ', ' + second,
              second + ', ' + first
            ]
          };

          var selectedBetComb1 = where(bets, { key: 'reverseForecast', displayValue: activeBet.combinations[0], eventId: this.activeGame._scheduleSvc.activeRound.eventId })[0];
          var selectedBetComb2 = where(bets, { key: 'reverseForecast', displayValue: activeBet.combinations[1], eventId: this.activeGame._scheduleSvc.activeRound.eventId })[0];

          if (selectedBetComb1 || selectedBetComb2) {
            var toRemove = selectedBetComb1 ? selectedBetComb1.uid : selectedBetComb2.uid;
            BetslipService.removeFromBetslip(toRemove, false);
            return;
          }

          var bet = where(HorseRaces.configuredBets, { key: 'reverseForecast' });
          BettingSvc.activateBet(bet[0]);

          if (BettingSvc.ticketInput.systemOdd) {
            delete BettingSvc.ticketInput.systemOdd;
          }

          BettingSvc.ticketInput.input = [second, first];

          var finalizedBet = BettingSvc.finalizeTicketInput()[0];

          if (HorseRaces.isScheduleActive) {
            finalizedBet.eventId = HorseRaces._scheduleSvc.activeRound.eventId;
            finalizedBet.event = HorseRaces._scheduleSvc.activeRound.eventIdToday;
          }
          var error = BetslipService.validateBet(
            finalizedBet,
            false
          );

          if (error.msg) {
            NabNotifications.show({
              message: error.msg,
              type: 'warning',
              delay: 3000
            });
          } else {
            BetslipService.addToBetslip(finalizedBet);
          }
        };

        this.toggleBet = function (activeBet) {
          var finalizedBet;
          var bet;
          var bets = BetslipService.ticket.getBets();
          var selectedBet = where(bets, { key: activeBet.bet, displayValue: activeBet.racers.toString() })[0];

          /** If same bet is clicked - set it inactive and remove it from betslip* */
          if (this.horseRacesUISvc.forecast[activeBet.racers]
                        && (this.activeGame.isScheduleActive ? this.horseRacesUISvc.scheduledEvents[this.activeGame._scheduleSvc.activeRound.eventId].forecast[activeBet.racers] : true)) {
            if (this.activeGame.isScheduleActive) {
              this.horseRacesUISvc.scheduledEvents[this.activeGame._scheduleSvc.activeRound.eventId].forecast[activeBet.racers] = false;
              selectedBet = where(bets, { key: activeBet.bet, displayValue: activeBet.racers, eventId: this.activeGame._scheduleSvc.activeRound.eventId })[0];
            }

            BetslipService.removeFromBetslip(selectedBet.uid, false);
            return;
          }

          var BettingSvc = HorseRaces.getBettingSvc();

          bet = where(HorseRaces.configuredBets, { key: activeBet.bet });
          BettingSvc.activateBet(bet[0]);
          finalizedBet = BettingSvc.finalizeTicketInput()[0];
          finalizedBet.disableEdit = true; // disable editing - winner,place
          finalizedBet.systemOdd = activeBet.value;

          finalizedBet.eventId = HorseRaces.gameInfo.eventId;

          if (HorseRaces.isScheduleActive) {
            finalizedBet.eventId = HorseRaces._scheduleSvc.activeRound.eventId;
            finalizedBet.event = HorseRaces._scheduleSvc.activeRound.eventIdToday;
          }

          var error = BetslipService.validateBet(
            finalizedBet,
            false
          );

          if (error.msg) {
            NabNotifications.show({
              message: error.msg,
              type: 'warning',
              delay: 3000
            });
          } else {
            BetslipService.addToBetslip(finalizedBet);
          }
        };

        this.enableActiveBets = function (bets) {
          bets.forEach(function (item) {
            if (item.clientId == 10 && !self.reverseForecast) {
              self.horseRacesUISvc.forecast[item.displayValue] = true;

              if (self.activeGame.isScheduleActive && (item.eventId >= self.activeGame.gameInfo.eventId)) {
                self.horseRacesUISvc.scheduledEvents[item.eventId].forecast[item.displayValue] = true;
              }
            }

            if (item.clientId == 12 && self.reverseForecast) {
              self.horseRacesUISvc.forecast[item.input[0] + '-' + item.input[1]] = true;
              self.horseRacesUISvc.forecast[item.input[1] + '-' + item.input[0]] = true;

              if (self.activeGame.isScheduleActive && (item.eventId >= self.activeGame.gameInfo.eventId)) {
                self.horseRacesUISvc.scheduledEvents[item.eventId].forecast[item.input[0] + '-' + item.input[1]] = true;
                self.horseRacesUISvc.scheduledEvents[item.eventId].forecast[item.input[1] + '-' + item.input[0]] = true;
              }
            }
          });
        };

        this.deactivateActiveBets = function () {
          self.deactivateForecastRacers();

          if (self.activeGame.isScheduleActive) {
            self.deactivateScheduledRacers();
          }
        };

        $scope.$watch(angular.bind(this, function () {
          return betslipSvc.ticket.bets; // this IS the this above!!
        }), function (newValue) {
          self.deactivateActiveBets();
          self.enableActiveBets(newValue);
        }, true);
      }
    });
})();
